import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export default function AlternativesEditor({ items, onChange, readOnly }) {
  const set = (i, k, v) => onChange(items.map((x, j) => (j === i ? { ...x, [k]: v } : x)));
  return (
    <div className="space-y-3" data-testid="alternatives-editor">
      <p className="text-xs text-slate-500">
        Alternative routes must be risk-assessed where required. Record when each alternative should be used.
      </p>
      {items.map((a, i) => (
        <div key={i} className="rounded-md border border-border p-4 space-y-3" data-testid={`alternative-${i}`}>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div className="space-y-1.5"><Label className="text-xs">Reason for alternative route</Label>
              <Input data-testid={`alt-reason-${i}`} value={a.reason || ""} disabled={readOnly} onChange={(e) => set(i, "reason", e.target.value)}
                placeholder="e.g. Primary bus unavailable, road closed, station closed" /></div>
            <div className="space-y-1.5"><Label className="text-xs">When it should be used</Label>
              <Input data-testid={`alt-when-${i}`} value={a.when_used || ""} disabled={readOnly} onChange={(e) => set(i, "when_used", e.target.value)} /></div>
            <div className="space-y-1.5"><Label className="text-xs">Transport</Label>
              <Input value={a.transport || ""} disabled={readOnly} onChange={(e) => set(i, "transport", e.target.value)} /></div>
            <div className="space-y-1.5"><Label className="text-xs">Route / stops</Label>
              <Input value={a.route || ""} disabled={readOnly} onChange={(e) => set(i, "route", e.target.value)} /></div>
          </div>
          <div className="space-y-1.5"><Label className="text-xs">Walking sections</Label>
            <Input value={a.walking_sections || ""} disabled={readOnly} onChange={(e) => set(i, "walking_sections", e.target.value)} /></div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div className="space-y-1.5"><Label className="text-xs">Hazards</Label>
              <Textarea rows={2} value={a.hazards || ""} disabled={readOnly} onChange={(e) => set(i, "hazards", e.target.value)} /></div>
            <div className="space-y-1.5"><Label className="text-xs">Controls</Label>
              <Textarea rows={2} value={a.controls || ""} disabled={readOnly} onChange={(e) => set(i, "controls", e.target.value)} /></div>
          </div>
          <div className="space-y-1.5"><Label className="text-xs">Instructions (child-friendly)</Label>
            <Textarea rows={2} data-testid={`alt-instructions-${i}`} value={a.instructions || ""} disabled={readOnly} onChange={(e) => set(i, "instructions", e.target.value)} /></div>
          <div className="space-y-1.5"><Label className="text-xs">Who the child should contact</Label>
            <Input value={a.contact || ""} disabled={readOnly} onChange={(e) => set(i, "contact", e.target.value)} /></div>
          {!readOnly && (
            <Button type="button" variant="ghost" className="h-9 text-red-600" data-testid={`alt-remove-${i}`}
              onClick={() => onChange(items.filter((_, j) => j !== i))}>
              <Trash2 className="h-4 w-4 mr-1" /> Remove
            </Button>
          )}
        </div>
      ))}
      {!readOnly && (
        <Button type="button" variant="outline" className="h-10" data-testid="alt-add-button"
          onClick={() => onChange([...items, { reason: "", when_used: "", transport: "", route: "", walking_sections: "", hazards: "", controls: "", instructions: "", contact: "" }])}>
          <Plus className="h-4 w-4 mr-2" /> Add alternative / emergency route
        </Button>
      )}
    </div>
  );
}
